module.exports = __webpack_public_path__ + "static/media/image6.62b7cc75.jpg";